import { validateLength, validatePresence } from 'ember-changeset-validations/validators';


export default {
  ids: [validatePresence(true), validateLength({ min: 1 })],
  date: [],
  priority: [],
  orderType: [],
  forceValidation: [],
};
